import React from 'react';
import { Link } from 'react-router-dom';

export default function Audiometry() {
  return (
    <>
      <div className='services-item container' id='audiometry'>
        <div className='row'>

          {/* Image */}
          <div className='col-lg-6 col-md-6 col-sm-12 p-0 order-lg-1 order-md-1 order-1'>
            <img
              className="img-fluid"
              src={`${process.env.PUBLIC_URL}/img/audio.png`}
              alt="Audiometry"
            />
          </div>

          {/* Description */}
          <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle p-0 order-lg-2 order-md-2 order-2'>
            <div className='services-item-content'>
              <h2>Audiometry <span>Test</span></h2>

              <p>
                FamPhy's Audiometry service evaluates hearing ability and
                helps identify different types and levels of hearing loss.
                Using advanced hearing assessment techniques, our specialists
                measure how well you can hear different sounds and frequencies,
                providing accurate results for effective hearing care.
              </p>

              <Link to="/contact" className="btn theam-btn-m">
                Contact Us
              </Link>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}